import React from 'react';
import classNames from 'classnames';
import { Popover, PopoverContent, PopoverChevron, PopoverAnchor } from '@fiverr-private/popover';
import { getContext } from '@fiverr-private/fiverr_context';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import { TooltipProps } from './types';
import classes from './index.module.scss';

const Tooltip = ({ position = 'top', size = 'md', appendToBody = false, onOpenChanged, content, children }: TooltipProps) => {
    const { isTouch, isMobile } = getContext();

    return (
        <Popover triggerEvent={isTouch ? 'click' : 'hover'} position={position} onOpenChanged={onOpenChanged}>
            <PopoverAnchor>
                {children}
            </PopoverAnchor>
            <PopoverContent backgroundColor={grey_1100}
                appendToBody={appendToBody}
                zIndex="tooltip"
                mobileFullWidth
                disablePadding
                disableBoxShadow>
                <PopoverChevron size={size}/>
                <div role="tooltip" className={classNames(classes.tooltip, {
                    [classes.mobile]: isMobile,
                    [classes.sizeSm]: size === 'sm'
                })}>
                    {content}
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default Tooltip;
